import React from 'react';
import colors from '../../theme/colors';

const statusColors = {
  normal: colors.success,
  warning: colors.warning,
  danger: colors.danger,
  offline: colors.textDim,
};

const styles = {
  card: {
    background: colors.surface,
    borderRadius: 8,
    padding: '14px 16px',
    minWidth: 0,
  },
  label: {
    fontSize: 11,
    color: colors.textMuted,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    marginBottom: 6,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  valueRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 4,
  },
  value: {
    fontSize: 22,
    fontWeight: 700,
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    lineHeight: 1,
  },
  unit: {
    fontSize: 12,
    color: colors.textMuted,
  },
};

export default function MetricCard({ label, value, unit, status, decimals = 1 }) {
  const displayVal = value == null ? '--'
    : typeof value === 'number' ? value.toFixed(decimals)
    : value;
  const valColor = status ? (statusColors[status] || colors.text) : colors.accent;

  return (
    <div style={styles.card}>
      <div style={styles.label}>{label}</div>
      <div style={styles.valueRow}>
        <span style={{ ...styles.value, color: valColor }}>{displayVal}</span>
        {unit && <span style={styles.unit}>{unit}</span>}
      </div>
    </div>
  );
}
